module.exports = __webpack_public_path__ + "img/nav-sentosa.f1d9ff20.svg";